angular.module('rjmNg.directives').directive "debugQueries", [
  () ->
    restrict: "E"
    templateUrl: "directive.debugQueries.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      dashboardItem: "="
      popView: "="
    controller: [
      "$http"
      "$url"
      "app"
      "Figures"
      "$routeParams"
      (
        $http
        $url
        app
        Figures
        $routeParams
      ) ->

        view = @

        _debugChart = (chart) ->
          chartId = chart.id
          if chartId is view.debug?.chartId
              return

          view.debug = {}
          view.loading = true
          $http(
            url: $url('/client/' + app.getClientId() + '/chart/' + chartId + '/debug/')
            method: 'GET'
          )
          .then( ({data}) =>
            if data instanceof Array
              view.debug.inputs = data
            else
              view.debug.inputs = [data]
            view.debug.chartId = chartId
            view.loading = false
          )
          .catch( ({data}) ->
            view.debug = data
            view.loading = false
          )

        _debugFigure = (figure) ->
          figureId = figure.id
          if figureId is view.debug?.figureId
            return

          view.debug = {}
          view.loading = true

          formattedRJQL = _syntaxHighlight(figure.query)

          options =
            params:
              dashboardId: $routeParams.dashId

          Figures.debug(figureId, options).then (result) ->
            if result instanceof Array
              view.debug.inputs = result
            else
              view.debug.inputs = [result]

            view.debug.rjqlQuery = formattedRJQL
            view.debug.figureId = figureId
            view.debug.rjqlId = figure.rjqlId

            view.loading = false
          , (error) ->
            view.debug = error
            view.debug.rjqlQuery = formattedRJQL

            view.loading = false

        _syntaxHighlight = (json) ->
          json = JSON.stringify(json, `undefined`, 2)  unless typeof json is "string"
          json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
          json.replace /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) ->
            cls = "number"
            if /^"/.test(match)
              if /:$/.test(match)
                cls = "key"
              else
                cls = "string"
            else if /true|false/.test(match)
              cls = "boolean"
            else cls = "null"  if /null/.test(match)
            "<span class=\"" + cls + "\">" + match + "</span>"

        view.initialize = () ->
          if view.dashboardItem.chart?
            _debugChart(view.dashboardItem.chart)
          else
            _debugFigure(view.dashboardItem.figure)

        view
    ]
    link: (scope, element, attr, view) ->

      scope.$watch 'view.popView.visible', (newVisible, oldVisible) ->
        if newVisible and newVisible isnt oldVisible
          view.initialize()

]
